import { render, staticRenderFns } from "./FeedbackAdminTools.vue?vue&type=template&id=63e60190&scoped=true&"
import script from "./FeedbackAdminTools.vue?vue&type=script&lang=js&"
export * from "./FeedbackAdminTools.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/default_accordion.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./FeedbackAdminTools.vue?vue&type=style&index=1&id=63e60190&prod&lang=css&"
import style2 from "./FeedbackAdminTools.vue?vue&type=style&index=2&id=63e60190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e60190",
  null
  
)

export default component.exports